import { BellRing, Check, Clock, X } from "lucide-react";

const LEVEL_STYLE = [
  { bg: "bg-amber-50", ring: "ring-amber-300", accent: "text-amber-800", pulse: "" },
  { bg: "bg-orange-100", ring: "ring-orange-400", accent: "text-orange-900", pulse: "animate-pulse" },
  { bg: "bg-rose-100", ring: "ring-rose-500", accent: "text-rose-900", pulse: "animate-pulse" },
];
const LEVEL_COPY = [
  "A small step, right now, is enough.",
  "Still with you. Two minutes is all it takes to start.",
  "You've got this. Do the tiniest version and check in — that's a win.",
];
const pointsAfter = (snoozes) => Math.max(4, 10 - 2 * snoozes);

export function AlarmHeader({ event, level }) {
  const s = LEVEL_STYLE[level];
  return (
    <>
      <div className={`flex items-center gap-2 text-xs font-bold uppercase tracking-widest ${s.accent}`}>
        <BellRing className={`w-5 h-5 ${s.pulse}`} /> {event.title}
        {event.snooze_count > 0 && <span className="ml-auto font-mono">snoozed ×{event.snooze_count}</span>}
      </div>
      <div>
        <h2 className="font-display text-3xl font-extrabold text-stone-900" data-testid="alarm-habit">{event.habit_title}</h2>
        <p className="text-stone-700 mt-2">{event.message || LEVEL_COPY[level]}</p>
      </div>
      <div className="text-xs text-stone-600 font-mono" data-testid="alarm-points-hint">
        Check in now: +{pointsAfter(event.snooze_count || 0)} pts
        {event.can_snooze ? ` · after snoozing: +${pointsAfter((event.snooze_count || 0) + 1)}` : ""}
      </div>
    </>
  );
}

export function AlarmControls({ event, onDone, onSnooze, onDismiss }) {
  return (
    <div className="grid gap-2">
      <button data-testid="alarm-done" onClick={onDone} className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-stone-900 text-white font-semibold hover:bg-emerald-700">
        <Check className="w-5 h-5" /> Done — check in
      </button>
      <div className="flex gap-2">
        <button data-testid="alarm-snooze" onClick={onSnooze} disabled={!event.can_snooze}
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full bg-white border border-stone-300 text-sm font-semibold text-stone-800 disabled:opacity-40">
          <Clock className="w-4 h-4" /> {event.can_snooze ? `Snooze ${event.snooze_minutes} min` : "No snoozes left"}
        </button>
        <button data-testid="alarm-dismiss" onClick={onDismiss} className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold text-stone-600 hover:bg-white/60">
          <X className="w-4 h-4" /> Not today
        </button>
      </div>
    </div>
  );
}

export const alarmStyle = (level) => LEVEL_STYLE[level];
